import React, { FC, useContext } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';

import getWrappedDisplayName from '../../../utils/hocs/getWrappedDisplayName';

import ControlGroupContext from '../../../components/form/#ControlGroupContext';

interface WithControlGroupContextProps {}

const withControlGroupContext = (WrappedComponent: FC<WithControlGroupContextProps>) => {
  const WithControlGroupContext = (props: WithControlGroupContextProps) => {
    const context = useContext(ControlGroupContext);

    return (
      <WrappedComponent
        {...props}
        {...context}
      />
    );
  };

  WithControlGroupContext.displayName = getWrappedDisplayName('WithControlGroupContext', WrappedComponent);

  return hoistNonReactStatics(WithControlGroupContext, WrappedComponent);
};

export default withControlGroupContext;
